import Typography from '@mui/material/Typography';


export default function InfoWatchlistText() {
  
  return (
<div>
    
    <Typography variant="h6" >

In this section, we scan genes included in disease panels curated by ClinGen (Clinical Genome Resource), 
an international research effort where experts have defined which genes are relevant for specific hereditary diseases.
<br /><br /> 
How to Read Your Results:<br /><br /> 
 Green color: No disease-associated variants were found.<br /> 
 Blue color: A variant with 'uncertain significance' was found in a gene linked to a disease phenotype.<br /> 
 Red color: A 'pathogenic' or 'likely pathogenic' variant was found in a gene linked to a disease phenotype.
 <br /><br /> 
Important:<br /> <br /> 
Finding a variant does not automatically mean you have the disease. 
It means that a change was found in a gene that has been associated with a specific condition. 
Your doctor or genetic counselor will help assess whether the variant follows a dominant or recessive inheritance pattern.
<br /><br /> 
 Dominant variants can cause disease even if only one copy of the gene is altered.<br /> 
 Recessive variants usually require both copies of the gene to be affected for a condition to appear.
 <br /><br /> 
Your healthcare provider will guide you through what the findings mean for you personally.

</Typography>    
</div>

   )
}